"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanUpTests = exports.allocateBucketForTest = exports.getBucketForTest = exports.Tests = void 0;
var tracking_1 = require("./tracking");
var storage = window.localStorage;
var Tests;
(function (Tests) {
})(Tests = exports.Tests || (exports.Tests = {}));
function getBucketForTest(testName) {
    var _a;
    try {
        var testInfo = (_a = JSON.parse(storage.getItem('abTests'))) !== null && _a !== void 0 ? _a : {};
        return testInfo[testName];
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
}
exports.getBucketForTest = getBucketForTest;
function randomVersion(versions) {
    return versions[Math.floor(Math.random() * versions.length)];
}
function allocateBucketForTest(testName, versions) {
    var _a;
    if (versions === void 0) { versions = ['control', 'experiment_a']; }
    try {
        var testInfo = (_a = JSON.parse(storage.getItem('abTests'))) !== null && _a !== void 0 ? _a : {};
        var params = new URLSearchParams(location.search);
        var forcedVersion = params.get("ab");
        // Already allocated
        var alreadyAllocated = testInfo[testName] !== undefined;
        if (alreadyAllocated && !forcedVersion) {
            return;
        }
        var version = forcedVersion || randomVersion(versions);
        testInfo[testName] = version;
        storage.setItem('abTests', JSON.stringify(testInfo));
        (0, tracking_1.trackEvent)('ab_test', {
            ab_test_name: testName,
            ab_test_version: testInfo[testName]
        });
        return version;
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
}
exports.allocateBucketForTest = allocateBucketForTest;
function cleanUpTests() {
    var _a;
    try {
        var testInfo = (_a = JSON.parse(storage.getItem('abTests'))) !== null && _a !== void 0 ? _a : {};
        // Remove tests that are not in the enum
        for (var testName in testInfo) {
            if (!(testName in Tests)) {
                delete testInfo[testName];
            }
        }
        storage.setItem('abTests', JSON.stringify(testInfo));
    }
    catch (err) {
        console.error(err);
    }
}
exports.cleanUpTests = cleanUpTests;
